import React, { useRef } from 'react';
import { Field, FieldArray, FieldArrayRenderProps } from "formik";
import { FieldInputProps, FormikProps } from 'formik';  // Add this import

// OR if that doesn't work, try this import instead:
import { FieldProps } from 'formik/dist/Field'; 
import { useSelector } from "react-redux";
import { RootState } from "../../../../app/features/store/store";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircleOutline";
import {
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Switch,
  Box,
  Button,
  InputAdornment
} from "@mui/material";
import FormikTextField from "../../../../components/common/formikFields/FormikTextField";
import { PRICE_PER_PACKAGE_TYPES, CUSTOM_FIELD_APPLICABLE_FOR_TYPES } from "../RateCardConstants";
interface FormValues {
  rateCardCustomFieldsData: Array<{
    ratecardCustomFieldName: string;
    ratecardCustomFieldAmount: string;
    ratecardCustemFieldPerPackage: string;
    ratecardCustomFieldApplicableFor: string;
  }>;
  // Add any other form fields you have
}



const CustomFields = (props: any) => {
  const { values, handleChange, handleBlur , setFieldValue} = props;
  const ArrayHelperRef = useRef<FieldArrayRenderProps>();

  
 
  return (
    <Grid container alignItems="center">
      <Grid item xs={12} sm={4}>
      <FormControlLabel
  id="show_custom_fields"
  name="show_custom_fields"
  label="Custom Fields"
  labelPlacement="start"
  sx={{ mt: 2 }}
  checked={values.show_custom_fields}
  control={
<Field>
  {({ field, form }: any) => (
    <Switch
      {...field}
      
      checked={field.value}
      onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        form.setFieldValue(field.name, checked);
        
        if (checked) {
          form.setFieldValue('rateCardCustomFieldsData', [{
            ratecardCustomFieldName: '',
            ratecardCustomFieldAmount: '',
            ratecardCustemFieldPerPackage: '',
            ratecardCustomFieldApplicableFor: '',
          }]);
        } else {
          form.setFieldValue('rateCardCustomFieldsData', []);
        }
      }}
    />
  )}
</Field>
  }
/>
      </Grid>

      {values.show_custom_fields && (
        <Grid container spacing={0} alignItems="center" sx={{ position: "relative", ml: -1 , marginLeft:'20px'}}>
          <FieldArray
            name="rateCardCustomFieldsData"
            render={(arrayHelpers) => {
              ArrayHelperRef.current = arrayHelpers;

              if (values.show_custom_fields && values.rateCardCustomFieldsData.length === 0) {
                arrayHelpers.push({
                  ratecardCustomFieldName: "",
                  ratecardCustomFieldAmount: "",
                  ratecardCustemFieldPerPackage: "",
                  ratecardCustomFieldApplicableFor: "",
                });
              }

              return (
                <>
                  <Box
                    sx={{
                      position: 'absolute',
                      left: '20px',
                      top: 24,
                      bottom: 24,
                      width: '2px',
                      backgroundColor: '#4caf50',
                      zIndex: 0
                    }}
                  />
                  
                  {values.rateCardCustomFieldsData.map((customField: any, index: number) => (
                    <Grid container item alignItems="center" spacing={1} key={index} sx={{ mb: 2 }}>
                      <Grid item sx={{ width: '40px', position: 'relative', zIndex: 1 }}>
                        <Box
                          sx={{
                            width: 24,
                            height: 24,
                            borderRadius: '50%',
                            bgcolor: '#4caf50',
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: 14,
                            fontWeight: 'bold',
                            ml: 1
                          }}
                        >
                          {index + 1}
                        </Box>
                      </Grid>

                      <Grid item sm>
                        <Grid container spacing={1}>
                          <Grid item xs={3}>
                            <FormikTextField
                              variant="outlined"
                              name={`rateCardCustomFieldsData.${index}.ratecardCustomFieldName`}
                              size="small"
                              label="Field Name"
                              fullWidth
                              margin="normal"
                            />
                          </Grid>

                          <Grid item xs={3}>
  <FormikTextField
    variant="outlined"
    name={`rateCardCustomFieldsData.${index}.ratecardCustomFieldAmount`}
    size="small"
    label="Price Per Package"
    InputProps={{
      startAdornment: (
        <>
          <Button 
            onClick={() => {
              const currentValue = values.rateCardCustomFieldsData[index].ratecardCustomFieldAmount || 0;
              setFieldValue(
                `rateCardCustomFieldsData.${index}.ratecardCustomFieldAmount`, 
                -currentValue
              );
            }}
            sx={{
              minWidth: '32px',
              padding: '4px',
              marginRight: '4px',
              // Added styles for the text
              fontSize: '20px',  // Makes the sign bigger
              fontWeight: 'bold', // Makes it bolder
              lineHeight: 1  // Helps center the sign vertically
            }}
          
          >
            {values.rateCardCustomFieldsData[index].ratecardCustomFieldAmount >= 0 ? '+' : '-'}
          </Button>
          <InputAdornment position="start">$</InputAdornment>
        </>
      ),
      inputProps: { 
        step: "0.01",
        style: { textAlign: 'right' }
      }
    }}
    type="number"
    fullWidth
    margin="normal"
  />
</Grid>

                          <Grid item xs={3}>
                            <FormikTextField
                              select
                              margin="normal"
                              name={`rateCardCustomFieldsData.${index}.ratecardCustemFieldPerPackage`}
                              label="Price Per Package Type"
                              size="small"
                              fullWidth
                              variant="outlined"
                              required
                            >
                              {PRICE_PER_PACKAGE_TYPES.map((type, idx) => (
                                <MenuItem key={idx} value={type}>{type}</MenuItem>
                              ))}
                            </FormikTextField>
                          </Grid>

                           <Grid item xs={2}>
                             <FormikTextField
                            select
                            margin="normal"
                            name={`rateCardCustomFieldsData.${index}.ratecardCustomFieldApplicableFor`}
                            label="Applicable For"
                            size="small"
                            fullWidth
                            variant={"outlined"}
                            required
                          >
                            {CUSTOM_FIELD_APPLICABLE_FOR_TYPES.map((type, index) => (
                              <MenuItem key={index} value={type}>
                                {type}
                              </MenuItem>
                            ))}
                          </FormikTextField>
                          </Grid>

                          <Grid item>
                            <IconButton
                              sx={{
                                bgcolor: '#4caf50',
                                color: 'white',
                                '&:hover': { bgcolor: '#388e3c' },
                                mt: 2
                              }}
                              onClick={() => {
                                // If this is the last item, also turn off the toggle
                                if (values.rateCardCustomFieldsData.length === 1) {
                                  setFieldValue('show_custom_fields', false);
                                }
                                arrayHelpers.remove(index);
                              }}
                            >
                              <RemoveCircleIcon fontSize="small" />
                            </IconButton>

                            <IconButton
                              sx={{
                                bgcolor: '#4caf50',
                                color: 'white',
                                '&:hover': { bgcolor: '#388e3c' },
                                mt: 2,
                                ml: 1 // Add some margin-left for spacing
                              }}
                              onClick={() => {
                                arrayHelpers.push({
                                  ratecardCustomFieldName: "",
                                  ratecardCustomFieldAmount: "",
                                  ratecardCustemFieldPerPackage: "",
                                  ratecardCustomFieldApplicableFor: "",
                                });
                              }}
                            >
                              <AddCircleIcon fontSize="small" />
                            </IconButton>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}

                  
                </>
              );
            }}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default CustomFields;